export enum DocumentsRoles {
  CREATOR = 'roles.documentsCreators',
  ASSIGNEE_CREATOR = 'roles.documentsAssigneeCreator',
  VIEWER = 'roles.documentsViewer',
  ASSIGNEE_VIEWER = 'roles.documentsAssigneeViewer',
  EDITOR = 'roles.documentEditor',
  ASSIGNEE_EDITOR = 'roles.documentsAssigneeEditor',
  PREFILL_PREFERENCES_MANAGER = 'roles.prefillPreferencesManager',
}
